import classNames from "classnames";
import { useCallback, useEffect, useRef, useState } from "react";
import CommonErrorPopup from "../../components/common/CommonErrorPopup";
import { useGetMobileVersionQuery, useUpdateMobileVersionMutation } from "../../app/services/mobilelogo";
import { getAuthUser } from "../../app/services/dashboard";
import { toast } from "react-toastify";
import { CloseIcon, EditIcon, SendIcon } from "../../components/common/Icons";
import MobileVersionDataPopup from "../../components/ProjectStatusPopup/MobileVersionDataPopup";
import LabelAndNumber from "../../components/SeoData/LabelAndNumber";
import LabelAndTextbox from "../../components/SeoData/LabelAndTextbox";
import Button from "../../components/common/Button";
import LabelAndEditor from "../../components/SeoData/LabelAndEditor";
const sample_data={
    version:35,
    content:'You app version is not up to date',
    iosLink:'ios',
    androidLink:'android'
}
const MobileVersionUpdatePopup = () => {
    const [uploading, setUploading] = useState<boolean>(false);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [editedData, setEditData] = useState<any>(sample_data);
    const [isSubmit, setIsSubmit] = useState<boolean>(false);
    const { data: mobile_version } = useGetMobileVersionQuery();
    const [updateData] = useUpdateMobileVersionMutation();
    const [commonMessage, setCommonMessage] = useState<any>([]);
    const [errorPopup, setErrorPopup] = useState<boolean>(false);
    var getUser = getAuthUser();
    useEffect(() => {
        if (mobile_version) {
            setEditData(mobile_version?.data);
        }

    }, [mobile_version]);
    const content_ref = useRef();
    const [errorMsg, setErrorMsg] = useState<string>("");
    const [version, setVersion] = useState<number>(0);
    const [content, setContent] = useState<string>("");
    const [iosLink, setIOSLink] = useState<string>("");
    const [androidLink, setAndroidLink] = useState<string>("");
    const clearData = () => {
        setVersion(0);
        setContent("");
        setIOSLink("");
        setAndroidLink("");
    };
    const saveVersionData = (data: any) => {
        const saveData = {
            version: data?.version,
            content: data?.content,
            iosLink: data?.iosLink,
            androidLink: data?.androidLink,
        };
        console.log("saveData ",saveData)
        if (saveData.version && saveData.content && saveData.iosLink && saveData.androidLink) {
            updateData(saveData)
                .unwrap()
                .then((payload: any) => {
                    setEditData("");
                    toast("Successfully Saved.", {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        type: "success",
                        theme: "light",
                    });
                    setIsSubmit(false);
                    setUploading(false);
                })
                .catch((error: any) => {
                    if (error?.data?.errors) {
                        setCommonMessage(Object.values(error?.data?.errors)?.join('. '));
                    } else {
                        setCommonMessage(error?.data?.message);
                    }

                    setIsSubmit(false);
                    setUploading(false);
                    // setIsOpenPopup(false);
                });
        } else {
            //setIsSubmit(false);
            setUploading(false);
        }

    };
    const handleSubmit = async () => {
        setIsSubmit(true);
        setUploading(true);
        const saveData = {
            version,
            content,
            iosLink,
            androidLink
        };
        if (editedData) {
            saveVersionData(saveData);
        }
    };

    useEffect(() => {
        if (editedData) {
            setVersion(editedData["version"]);
            setContent(editedData["content"]);
            setAndroidLink(editedData["androidLink"]);
            setIOSLink(editedData["iosLink"]);
        }
    }, [editedData]);
    const change_data = (value: any, key: string) => {
        if (key == "version") {
            setVersion(value);
        }
        else if (key == "content") {
            setContent(value);
        }
        else if (key == "iosLink") {
            setIOSLink(value);
        }
        else if (key == "androidLink") {
            setAndroidLink(value);
        }
    }
    return (
        <div className="px-2 sm:px-4 py-4 bg-white sm:mt-[25px] mt-0 font-poppins text-13 font-semibold text-[#858795] tracking-[-0.03rem] w-full h-full rounded-xl pt-3 pb-8 sm:pt-3 sm:pb-9">
            <div>
                <div className="text-left">
                    <div className="mt-5">
                        <LabelAndNumber label="Version Number" value={version} setValue={(value) => change_data(value, 'version')} />
                    </div>
                    <div className="mt-5">
                        <LabelAndEditor refId={content_ref} isRequired={true} label="Popup Content" value={content} setValue={(value) => change_data(value, 'content')} />
                    </div>
                    <div className="mt-5">
                        <LabelAndTextbox isRequired={true} label="IOS Link" value={iosLink} setValue={(value) => change_data(value, 'iosLink')} />
                    </div>
                    <div className="mt-5">
                        <LabelAndTextbox isRequired={true} label="Android Link" value={androidLink} setValue={(value) => change_data(value, 'androidLink')} />
                    </div>
                </div>
                <div className="pb-5 pt-5 flex justify-between items-center">
                    <div className="flex flex-wrap">
                        <div className="flex px-2 justify-center items-center">
                            <Button
                                type="button"
                                label={
                                    <span className="flex items-center text-12 leading-[18px]">
                                        <SendIcon className="mr-[10px] group-hover:opacity-50 transition-all duration-300" />
                                        {editedData ? "Update" : "Save"}
                                    </span>
                                }
                                onClick={() => {
                                    handleSubmit();
                                }}
                                variant="no-outline"
                                size="lg"
                                customClass={classNames(
                                    uploading ? " pointer-events-none opacity-50" : "",
                                    "hover:bg-vorpblue mr-2 py-2 lg:py-2 px-3 custom-button-size"
                                )}
                            />
                            
                        </div>
                    </div>
                    <p
                        className={classNames(
                            isSubmit || errorMsg ? "" : "hidden",
                            "mb-2 font-poppins text-12 text-redPink"
                        )}
                    >
                        {errorMsg}
                    </p>
                </div>
            </div>
            {/* <MobileVersionDataPopup
                setIsOpen={setIsOpen}
                isOpen={isOpen}
                editedData={editedData}
                setEditData={setEditData}
                setIsSubmit={setIsSubmit}
                isSubmit={isSubmit}
                setUploading={setUploading}
                title="Mobile Version Update"
                updatePopupData={saveData}
                uploading={uploading}
            /> */}
            <CommonErrorPopup
                show={errorPopup}
                setShow={setErrorPopup}
                message={commonMessage}
            />
        </div>
    );
};
export default MobileVersionUpdatePopup;
